import { useState, useEffect } from 'react';

interface DashboardTableHeaderProps {
  allChecked: boolean;
  onCheckAll: (checked: boolean) => void;
}

export default function DashboardTableHeader({
  allChecked,
  onCheckAll,
}: DashboardTableHeaderProps) {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      const authData = localStorage.getItem('auth');
      if (authData) {
        const parsedData = JSON.parse(authData);
        setIsAdmin(parsedData.user?.role === 'admin');
      }
    } catch (error) {
      console.error('Error reading localStorage:', error);
    }
  }, []);

  return (
    <thead>
      <tr className="text-left text-gray-700 bg-gray-100 border-b">
        {isAdmin && (
          <th className="p-4">
          <input
            className="form-checkbox h-5 w-5 text-blue-600"
            type="checkbox"
            checked={allChecked}
            onChange={e => onCheckAll(e.target.checked)}
            aria-label="Select all pitches"
          />
        </th> ) }
        {isAdmin && <th className="p-4">Company</th>}
        <th className="p-4">Artist</th>
        <th className="p-4">Release</th>
        <th className="p-4">Date</th>
        <th className="p-4">Pitch Due</th>
        <th className="p-4">Pitch</th>
        <th className="p-4">Pitch Status</th>
      </tr>
    </thead>
  );
}